export enum QuoteRequestField {
  CommissionRate = 'CommissionRate',
  Volume = 'Volume',
  BilledRate = 'BilledRate',
}
